import { IconInfo } from "@decibeltrade/react-icons";
import { css, cva, cx } from "styled-system/css";

type InfoBlockVariant = "default" | "warning" | "error" | "success" | "info";

interface InfoBlockProps {
  variant?: InfoBlockVariant;
  className?: string;
  children: React.ReactNode;
}

export const InfoBlock = ({ variant = "default", children, className }: InfoBlockProps) => {
  return (
    <div className={cx(infoBlockStyles({ variant }), className)}>
      <IconInfo
        className={css({
          h: "16",
          w: "16",
        })}
      />
      <span className={textStyles}>{children}</span>
    </div>
  );
};

const infoBlockStyles = cva({
  base: {
    display: "flex",
    borderRadius: "200",
    p: "16",
    gap: "8",
  },
  variants: {
    variant: {
      default: {
        bg: "background.secondary",
        color: "text.primary",
      },
      warning: {
        bg: "background.secondary",
        color: "text.warning",
      },
      error: {
        bg: "background.negative",
        color: "text.negative",
      },
      success: {
        bg: "background.positive",
        color: "text.positive",
      },
      info: {
        bg: "background.secondary",
        color: "text.highlight",
      },
    },
  },
});

const textStyles = css({
  flex: "1",
  textStyle: "body.md",
  textAlign: "left",
});
